import { populatedCampaignSchema } from "@redotech/redo-model/campaigns/campaign-definition";
import * as z from "zod/v4";

export const removeABTestVariant = {
  name: "removeABTestVariant" as const,
  input: z.object({ campaignId: z.string(), templateId: z.string() }),
  output: populatedCampaignSchema,
};
